import React from 'react';

import PropTypes from 'prop-types';

import styles from './ProgressBar.module.scss';

const ProgressBar = ({ currentStep, totalSteps, label }) => {
  const pct = Math.round((currentStep / totalSteps) * 100);

  return (
    <div className={styles.progress}>
      <div className={styles.progressTop}>
        <span className={styles.progressLabel}>
          Step {currentStep} of {totalSteps}
        </span>
        {label && <span className={styles.progressSub}>{label}</span>}
      </div>
      <div
        className={styles.progressTrack}
        role="progressbar"
        aria-label="Progress"
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-valuenow={currentStep}
      >
        <div
          className={styles.progressFill}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  label: PropTypes.string,
  subLabel: PropTypes.string,
};

ProgressBar.defaultProps = {
  label: '',
  subLabel: '',
};

export default ProgressBar;
